export default "__VITE_ASSET__DCxVMMDU__"